import ConfirmAccountRecoveryPage from './ConfirmAccountRecoveryPage';

export default ConfirmAccountRecoveryPage;


// WEBPACK FOOTER //
// ./src/components/pages/ConfirmAccountRecoveryPage/index.js